import { TooltipPoint } from './Point';
export { TooltipPoint };
//# sourceMappingURL=main.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-charts/dist/es/tooltip/main.js
// module id = 2457
// module chunks = 29